import React from 'react';

import { prependWithZero } from '@ael/core-api';
import classNames from 'classnames';

import './AudioCountdown.scss';

type AudioCountdownProps = {
  /** Current time in which the audio is. Either paused or playing. */
  currentTime: number;
  /** How long will the audio play. If null, then the duration is not available yet e.g. audio metadata are not loaded yet. */
  duration: number | null;
  /** True if the audio is currently playing. */
  isPlaying: boolean;
};

export const AudioCountdown = (props: AudioCountdownProps) => {
  const duration = props.duration ? props.duration : 0;
  const timeDisplayValue = secondsToDisplayValue(Math.round(duration - props.currentTime));

  return (
    <span
      className={classNames('audio-countdown', {
        'audio-countdown--paused': !props.isPlaying,
      })}
    >
      {props.duration
        ? `${prependWithZero(timeDisplayValue.minutes)}:${prependWithZero(timeDisplayValue.seconds)}`
        : '--:--'}
    </span>
  );
};

type TimeDisplayValue = {
  minutes: number;
  seconds: number;
};

const secondsToDisplayValue = (seconds: number): TimeDisplayValue => {
  // Edge case in case of corrupted audio file.
  if (seconds < 0) {
    return {
      minutes: 0,
      seconds: 0,
    };
  }

  return {
    minutes: Math.floor(seconds / 60),
    seconds: seconds % 60,
  };
};
